import { Link } from "react-router-dom";
import { animeList } from "@/mocks/anime";

const cats = ["热血", "奇幻", "科幻", "恋爱", "悬疑", "古风", "日常", "战斗"];

export default function CategorySection() {
  const pick = (name: string) => animeList.find((a) => a.category === name);

  return (
    <section className="bg-background-900/40 py-10 md:py-14">
      <div className="container-site">
        <div className="mb-6">
          <h2 className="flex items-center gap-2 font-heading text-2xl text-foreground-50 md:text-3xl">
            <i className="ri-grid-fill text-primary-500" />
            番剧分类浏览
          </h2>
          <p className="mt-1 text-sm text-foreground-400">按类型挑选，轻松找到心头好</p>
        </div>

        <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-4">
          {cats.map((c) => {
            const rep = pick(c);
            return (
              <Link
                key={c}
                to={`/list?cat=${encodeURIComponent(c)}`}
                className="group relative aspect-[16/11] overflow-hidden rounded-lg border border-background-800"
              >
                {rep && (
                  <img
                    src={rep.cover}
                    alt={`${c}类型动漫合集`}
                    title={`${c}番剧在线观看下载`}
                    className="h-full w-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
                  />
                )}
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/30 to-transparent" />
                <div className="absolute inset-x-0 bottom-0 flex items-center justify-between p-4">
                  <span className="font-heading text-lg text-foreground-50">{c}</span>
                  <span className="flex h-8 w-8 items-center justify-center rounded-full bg-primary-500/90 text-background-950 transition-transform group-hover:translate-x-1">
                    <i className="ri-arrow-right-line" />
                  </span>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
}